export const GROUP_TYPE = {
  NORMAL: 'normal',
  FIRM: 'firm',
  CRUISE: 'cruise'
}

export const PERMISSION_TYPE = {
  DashboardStatistics: '/Dashboard/Statistics', //官網流量統計
  DashboardTourControl: '/Dashboard/TourControl', //團控表
  DashboardMeetingRoomSchedule: '/Dashboard/MeetingRoomSchedule', //預約會議室
  DashboardRemittanceOrder: '/Dashboard/RemittanceOrder', //匯款單套表列印
  TravelGroups: '/TravelGroups',
  TravelGroupsDelete: '/TravelGroups/Delete',
  GiftsProcess: '/Gifts/Process',
  GiftsPosts: '/Gifts/Posts', // 過帳歷史
  GiftsPostsProcess: '/Gifts/Posts/Process', // 過帳處理
  GiftsPurchases: '/Gifts/Purchases', // 進貨列表
  GiftsPurchasesCreate: '/Gifts/Purchases/Create',
  GiftsPurchasesUpdate: '/Gifts/Purchases/Update',
  GiftsPurchasesGenerate: '/Gifts/Purchases/Generate', // 產生進貨單號
  GiftsPurchasesImport: '/Gifts/Purchases/Import', // 進貨
  GiftsPurchasesVoid: '/Gifts/Purchases/Void', // 作廢
  GiftsPurchasesDelete: '/Gifts/Purchases/Delete',
  GiftsTransfers: '/Gifts/Transfers',
  GiftsTransfersProcess: '/Gifts/Transfers/Process',
  GiftsApplications: '/Gifts/Applications', // 贈品申請列表
  GiftsApplicationsProcess: '/Gifts/Applications/Process', // 贈品申請處理
  GiftsReviews: '/Gifts/Reviews', // 贈品審核列表
  GiftsReviewsProcess: '/Gifts/Reviews/Process', // 贈品審核處理
  GiftsReviewsCancel: '/Gifts/Reviews/Cancel' // 贈品審核銷帳
}

export const BLOG_SOURCE_TYPES = {
  FANTASY_TOURS: 'FantasyTours',
  JOURTRIP: 'Jourtrip'
}

export const GIFT_APPLICATION_STATE_TYPES = {
  NEW: 'new',
  PENDING: 'pending',
  AUDIT: 'audit',
  RETURN: 'return',
  REJECT: 'reject',
  VOID: 'void',
  CANCEL: 'cancel'
}

export const GIFT_REVIEW_APPLY_TYPES = {
  FIT: 'fit',
  GROUP: 'group',
  REPURCHASE: 'repurchase',
  RETURN: 'return',
  POINT: 'point',
  SALE: 'sale',
  REDEEM: 'redeem'
}

export const GIFT_REVIEW_STATE_TYPES = {
  PENDING: 'pending',
  AUDIT: 'audit',
  LOCK: 'lock',
  CANCEL: 'cancel',
  REJECT: 'reject',
  VOID: 'void',
  DELETE: 'delete'
}

export const MEETING_SCHEDULE_NOTIFY_TYPE = {
  NONE: 'none',
  ALL: 'all',
  SPECIFY: 'specify'
}

export const MEETING_TYPE = {
  BRIEFING: 'briefing',
  LESSON: 'lesson'
}

export const MEETING_PLACE_TYPE = {
  INNER: 'inner',
  OTHER: 'other'
}

// 已改為導向後台 2.0 的頁面，側邊選單會在尾巴加上圖示提示
export const ADMIN2_REDIRECT_PATHS = [
  '/basic/leaders',
  '/basic/travel-areas',
  '/company/satisfactions',
  '/company/seminars',
  '/company/blog',
  '/company/blog-shares',
  '/company/tour-leaders',
  '/meeting-room-schedules',
  '/company/magazine',
  '/contract/contract-case',
  '/contract/contract-templates',
  '/order-management/cruise-inquiries',
  '/order-management/order-process',
  '/order-management/inquiry-process',
  '/order-management/demands',
  '/order-management/complaints',
  '/order-management/travel-group-report-records',
  '/order-management/publication-demands'
]

// 贈品專區交棒開關打開後才視為已導向後台 2.0 的頁面
export const ADMIN2_GIFT_HANDOVER_PATHS = [
  '/gifts/management',
  '/gifts/purchases',
  '/gifts/transfers',
  '/gifts/applications',
  '/gifts/reviews'
]

// 已停用的頁面，側邊選單會在名稱右邊顯示停用圖示
// 以 / 結尾者為整組停用（如首頁管理底下全部）
export const ADMIN1_DISABLED_PATHS = [
  '/home/',
  '/company/edm',
  '/company/subscriptions',
  '/company/news',
  '/company/honey-moons',
  '/company/lectures',
  '/company/offers',
  '/company/bank-offers',
  '/company/tourism-news',
  '/order-management/lecture-orders',
  '/area/banners',
  '/area/area-regions',
  '/area/catalogs',
  '/area/catalog-banners',
  '/area/catalog-tourist-infos',
  '/area/catalog-travel-infos',
  '/products/delete',
  '/products/export',
  '/travel-groups',
  '/travel-groups/advance',
  '/travel-groups/delete',
  '/basic/banks',
  '/basic/business-entities',
  '/basic/hotels',
  '/basic/air-lines',
  '/basic/flight-schedules',
  '/basic/weathers',
  '/basic/pages-seo',
  '/basic/countries',
  '/basic/cities',
  '/basic/regions',
  '/basic/areas',
  '/firm',
  '/firm/',
  '/mis/country-templates',
  '/mis/city-templates',
  '/mis/traveler-types',
  '/mis/attributes',
  '/log/'
]
